import { FC } from "react";
import classNames from "classnames";

import { LegendProps } from "./Legend.type";

const Legend: FC<LegendProps> = ({ border = true, direction = "horizontal", items, compact = false }) => {
	return (
		<ul
			className={classNames("flex flex-wrap", {
				"p-3 gap-4": !compact,
				"p-2 gap-2": compact,
				"flex-col": direction === "vertical",
				"p-5": direction === "vertical" && !compact,
				border: border,
			})}
		>
			{items.map((item) => (
				<li key={item.label + item.color} className={classNames("flex items-center", compact ? "gap-1.5" : "gap-2")}>
					<span style={{ backgroundColor: item.color }} className={classNames("shrink-0", compact ? "w-3 h-3" : "w-4 h-4")} />
					<span className={compact ? "text-xs leading-tight" : "text-base"}>{item.label}</span>
				</li>
			))}
		</ul>
	);
};

export { Legend };
